import { render, staticRenderFns } from "./PreguntasInstitucionesExportar.vue?vue&type=template&id=db0f2814&scoped=true"
import script from "./PreguntasInstitucionesExportar.vue?vue&type=script&lang=js"
export * from "./PreguntasInstitucionesExportar.vue?vue&type=script&lang=js"
import style0 from "./PreguntasInstitucionesExportar.vue?vue&type=style&index=0&id=db0f2814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0f2814",
  null
  
)

export default component.exports